import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectPeriodo = () => {
  const availablePeriodi = useSelector(
    state => state.selection.availablePeriodi,
  )
  const selectedPeriodo = useSelector(state => state.selection.selectedPeriodo)

  const { setSelectedPeriodo } = useSelectionSet()

  const value = availablePeriodi?.includes(selectedPeriodo)
    ? selectedPeriodo
    : undefined

  return (
    <Grid size={{ xs: 12, md: 3 }}>
      <Select
        id='available-periodi'
        label='Periodo'
        value={value}
        options={availablePeriodi}
        disabled={!availablePeriodi}
        onChange={setSelectedPeriodo}
      />
    </Grid>
  )
}

export default SelectPeriodo
